module.exports = "/fonts/vendor/lightgallery/src/lg.svg?2ec2cb2199d4d881e6a6ad86690f6add";